export default {
  google_login: 'Sign in with Google',
  google_logout: 'Sign out from Google',
  slack_login: 'Sign in with Slack',
  slack_logout: 'Sign out from Slack',
};
